import { useContext } from 'react'

import { ClientContext } from '@percent/product-nomination-form/context/client/clientContext/ClientContext'
import { nominationService } from '@percent/product-nomination-form/api/nominationForm/nominationForm.actions'
import { countriesService } from '@percent/product-nomination-form/api/countries/countries.actions'
import { organisationsService } from '@percent/product-nomination-form/api/organisations/organisations.actions'
import { registriesService } from '@percent/product-nomination-form/api/registries/registries.actions'

export const useServices = () => {
  const client = useContext(ClientContext)

  if (client === undefined) {
    throw new Error('ClientContext must be within ClientProvider')
  }

  return {
    nominationService: nominationService({ client }),
    countriesService: countriesService({ client }),
    organisationsService: organisationsService({ client }),
    registriesService: registriesService({ client }),
  }
}
